module.exports = __webpack_public_path__ + "static/media/avaliacaoFormativaIcon.4a25282e.svg";